import ngRouter from '@uirouter/angularjs';
import maIsohService from "../../services/maIsohService/maIsohService";
import updateServiceModule from "../../services/updateService/updateService";
import ngDialogModule from 'ng-dialog';
import usefulDirectives from "../../helpers/usefulDirectives";
import userServiceModule from "../../services/userService/userService";
import carDimensionsModule from "../../services/carDimensions/carDimensions";
import carPartsDimensionsModule from "../../services/carPartsDimensions/carPartsDimensions";
import pscDimensionsModule from "../../services/pscDimensions/pscDimensions";
import countryDimensionsModule from "../../services/countryDimensions/countryDimensions";

import appName from '../../appName';
import backupServiceModule from "../../services/backupService/backupService";
import regionDimensionsModule from "../../services/regionDimensions/regionDimensions";
import notificationService from '../../services/notificationService/notificationService';
import moment from 'moment/moment';

export default angular.module('settings', [
	ngRouter,
	maIsohService,
	notificationService,
	updateServiceModule,
	ngDialogModule,
	usefulDirectives,
	userServiceModule,
	carDimensionsModule,
	carPartsDimensionsModule,
	'trNgGrid',
	pscDimensionsModule,
	countryDimensionsModule,
	backupServiceModule,
	regionDimensionsModule
]).config(($stateProvider) => {
	$stateProvider.state({
		name: 'autovraky.settings',
		url: 'settings',
		controller: 'SettingsController',
		templateUrl: 'modules/settings/settings.tpl.html',
		controllerAs: 'ctrl'
	});
})
	/** @ngInject */.controller('SettingsController', function($scope, maIsoh, notify, ngDialog, userService, carDimensions, carPartsDimensions,
															   backupService, $timeout, $log, $state) {
		$scope.userService = userService;
		$scope.altInputFormats = [
			'd.M.yyyy'
		];
		this.lastPcp = userService.getPcp();
		this.dateOptions = {
			'close-text': 'Zavřít'
		};

		/**
		 * Infinite date for datum souhlasu
		 */
		this.infiniteDate = moment('17.11.2222', 'DD.MM.YYYY').toDate();

		this.appName = appName;

		/**
		 * Is this date our infinite date?
		 * @param date
		 * @returns {*}
		 */
		this.isInfiniteDate = (date) => {
			return moment(date).isSame(moment(this.infiniteDate));
		};

		this.model = userService.getUserSettings();
		this.appSettings = userService.getAppSettings();

		if (angular.isDefined(this.model.agreement.datum_vydani) && this.model.agreement.datum_vydani !== null) {
			this.model.agreement.datum_vydani = new Date(this.model.agreement.datum_vydani);
		}

		if (angular.isDefined(this.model.agreement.datum_souhlasu) && this.model.agreement.datum_souhlasu !== null) {
			this.model.agreement.datum_souhlasu = new Date(this.model.agreement.datum_souhlasu);
		}

		this.datumVydaniOpened = false;
		this.datumSouhlasuOpened = false;
		this.loadingCarDimensions = false;
		this.loadingCarPartsDimensions = false;

		this.backupDir = userService.getBackupDir();
		this.backups = [];

		this.initBackups = () => {
			this.backupDir = userService.getBackupDir();
			if (angular.isDefined(this.backupDir)) {
				this.backups = backupService.getBackups();
			}
		};

		this.initCarDimensions = () => {
			this.carDimensions = carDimensions.getDimensions();
			this.carDimensionsCount = this.carDimensions.length;
			this.carDimensionsLastSync = carDimensions.getLastSync();
		};

		this.initCarPartsDimensions = () => {
			this.carPartsDimensions = carPartsDimensions.getDimensions();
			this.carPartsDimensionsCount = this.carPartsDimensions.length;
			this.carPartsDimensionsLastSync = carPartsDimensions.getLastSync();
		};

		this.initCarDimensions();
		this.initCarPartsDimensions();
		this.initBackups();

		this.continueToHome = () => {
			$state.go('home');
		};

		/**
		 * Save facility info
		 */
		this.saveFacility = (form) => {
			if (angular.isUndefined(form) || form.$valid) { //form can be undefined when using Test connection from settings page
				userService.setUserSettings(this.model);
				userService.setAppSettings(this.appSettings);
				notify.success('Údaje uloženy');
			} else {
				debugger;
				notify.error('Vyplňte prosím všechna povinná pole. Správně vyplněné pole je označeno zelenou barvou. Žlutá pole jsou povinná, bílá nepovinná');
			}
		};

		/**
		 * Save application settings
		 */
		this.saveAppSettings = () => {
			userService.setAppSettings(this.appSettings);
			notify.success('Údaje uloženy');
		};

		this.setPlatnostSouhlasuToInfinite = () => {
			this.model.agreement.datum_souhlasu = this.infiniteDate;
		};

		/**
		 * Test API by trying to get detail about this user
		 * Pyramid of doom callback hell is intetional, because ISOH API return the same error message on all messages
		 */
		this.testApi = () => {
			this.testingApi = true;
			let messages = [];

			notify.info('Kontakuji MA ISOH, chviličku strpení prosím');
			$log.debug('Kontakuji MA ISOH pro init sync');

			maIsoh.testApi().then((response) => {
				messages.push('Načtení informací o aplikaci ... OK');
				$log.debug('Info o APP nacteno');

				maIsoh.getUserInfo(this.appSettings.user.login).then(() => {
					messages.push('Ověření uživatelského jména a hesla ... OK');
					$log.debug('Username a pass overeno');

					maIsoh.getFacilityInfo(this.model.workplace.ic, this.model.workplace.zuj, this.model.workplace.provoz).then((response) => {
						if (angular.isDefined(response.json.zarizeni.ident)) {
							this.model.workplace.ident = response.json.zarizeni.ident;
							$log.debug('Zarizeni overeno');

							messages.push('Ověření informací o zařízení ... OK');
							messages.push('Spojení se serverem funguje');

							$timeout(() => {
								this.loadCarPartsDimensions();
							}, 500);

							$timeout(() => {
								this.loadCarDimensions();
							}, 1000);
						} else {
							$log.debug('Zarizeni neexistuje');
							throw new Error('Toto zařízení neexistuje');
						}
					}).then(() => {
						this.saveFacility();
						notify.success(messages.join('<br>'));
					}).catch((error) => {
						if (error.message) {
							notify.error('Uživatelské jméno a heslo neodpovídá nastaveým parametrům zařízení. Zkontrolujte IČ, provoz a ZÚJ  - ' + error.message);
							$log.debug('Login a pass Ok ale zarizeni je blbe');
						}
					}).finally(() => {
						this.testingApi = false;
					});
				}).catch((error) => {
					if (error.message) {
						notify.error('Uživatelské jméno nebo heslo není správné, ověřte správnost - ' + error.message);
						$log.debug('Login a pass je blbe');
					}

					this.testingApi = false;
				});
			}).catch((error) => {
				if (error.message) {
					notify.error('Spojení se službou nebylo navázáno - ' + error.message);
					$log.debug('Server nejde');
				}

				this.testingApi = false;
			});
		};

		this.checkUpdates = () => {
		};

		/**
		 * Open modal for changing password
		 */
		this.openPasswordModal = () => {
			ngDialog.open({
				template: 'modules/settings/changePasswordModal.tpl.html',
				controller: 'ChangePasswordController',
				controllerAs: 'ctrl'
			}).closePromise.then((response) => {
				if (angular.isDefined(response.value.password)) {
					notify.success('Heslo bylo úspěšně změněno');
					this.appSettings = userService.getAppSettings();
					// this.testApi();
				}
			});
		};

		/**
		 * Load car dimensions from server
		 */
		this.loadCarDimensions = () => {
			this.loadingCarDimensions = true;
			maIsoh.loadCarDimensions(carDimensions.getLastSync()).then((result) => {
				if (angular.isDefined(result.json.znacky.item)) {
					carDimensions.setDimensions(result.json.znacky.item);

					this.carDimensionsCount = result.json.znacky.item.length;

					notify.success('Číselník značek synchronizován - ' + this.carDimensionsCount + ' položek');
				} else {
					notify.success('Číselník značek je aktuální');
				}

				carDimensions.markLastSync();
				this.carDimensionsLastSync = carDimensions.getLastSync();
				this.initCarDimensions();
			}).catch((error) => {
				notify.error(error.message);
			}).finally(() => {
				this.loadingCarDimensions = false;
			});
		};

		/**
		 * Load car parts dimensions from server
		 */
		this.loadCarPartsDimensions = () => {
			this.loadingCarPartsDimensions = true;
			maIsoh.loadCarPartsDimensions(carPartsDimensions.getLastSync()).then((result) => {
				if (angular.isDefined(result.json.casti.item)) {
					carPartsDimensions.setDimensions(result.json.casti.item);
					this.carPartsDimensionsCount = result.json.casti.item.length;

					notify.success('Číselník částí synchronizován - ' + this.carPartsDimensionsCount + ' položek');
				} else {
					notify.success('Číselník částí je aktuální');
				}

				carPartsDimensions.markLastSync();
				this.carPartsDimensionsLastSync = carPartsDimensions.getLastSync();
				this.initCarPartsDimensions();
			}).catch((error) => {
				notify.error(error.message);
			}).finally(() => {
				this.loadingCarPartsDimensions = false;
			});
		};

		/**
		 * Dimension selector callbacks
		 */
		this.workplacePscSelected = (selected) => {
			this.model.workplace.obec = selected.obec;
		};

		this.workplaceZujSelected = (selected) => {
			this.model.workplace.orp = selected.orp;
		};

		/**
		 * Pick backup directory
		 */
		this.pickDirectory = () => {
			let path = dialog.showOpenDialog({
				properties: ['openDirectory']
			});

			if (angular.isDefined(path)) {
				userService.setBackupDir(path[0]);
				this.backupDir = path[0];

				notify.success('Zálohování nastaveno do adresáře: ' + path[0]);

				this.refreshBackups();
			}
		};

		/**
		 * Refresh backups to new index
		 */
		this.refreshBackups = () => {
			backupService.indexBackups();
			this.initBackups();

			notify.success('Načteno ' + this.backups.length + ' záloh');
		};

		/**
		 * Removes backup
		 * @param backup
		 */
		this.removeBackup = (backup) => {
			backupService.removeBackup(backup);
			notify.success('Záloha smazána');
			this.initBackups();
		};

		/**
		 * Restore backup
		 * @param backup
		 */
		this.restoreBackup = (backup) => {
			backupService.restoreBackup(backup);
			notify.success('Záloha obnovena');
		};

		/**
		 * Creates a new backup
		 */
		this.createBackup = () => {
			try {
				backupService.createBackup();
				this.initBackups();
				notify.success('Záloha vytvořena');
			} catch (e) {
				notify.error(e);
			}
		};

		/**
		 * Restores data from FBK file from Freeware Autovraky
		 */
		this.restoreFreewareData = () => {
		};

		/**
		 * Sets default server values
		 */
		this.setDefaultServer = () => {
			this.appSettings.apiUrl = 'https://autovraky.mzp.cz/autovrak/service/v7';
			this.appSettings.apiWSDLUrl = 'https://autovraky.mzp.cz/autovrak/service/wsdl/v7';
			this.saveAppSettings();

			notify.success('Prostředí nastaveno na ' + this.appSettings.apiUrl);
		};

		this.setTestingServer = () => {
			this.appSettings.apiUrl = 'http://autovraky-test.mzp.cz/autovrak/service/v7';
			this.appSettings.apiWSDLUrl = 'http://autovraky-test.mzp.cz/autovrak/service/wsdl/v7';
			this.saveAppSettings();

			notify.success('Prostředí nastaveno na ' + this.appSettings.apiUrl);
		};
	}).controller('ChangePasswordController', function($scope, maIsoh, userService, notify) {
		this.savePassword = () => {
			notify.info('Měním heslo v MA ISOH, chvilku strpení prosím...');
			this.changingPassword = true;
			maIsoh.changePassword(this.user.login, this.oldPassword, this.newPassword).then(() => {
				userService.setUserPassword(this.newPassword);
				$scope.closeThisDialog({password: angular.copy(this.newPassword)});
			}).catch((error) => {
				notify.error(error.message);
			}).finally(() => {
				this.changingPassword = false;
			});
		};

		this.user = userService.getUser();
	}).name;



// WEBPACK FOOTER //
// build/modules/settings/settings.js